import React from "react";
import './Comeunirti.css'
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import imageUrl1 from "../../Assets/servizi7.png";

function Comeunirti() {
  return (
    <section>
      <Container fluid className="home-section" id="comeunirti">
        <Container className="Comeunirti-content"> 
            <Row md={7} className="Comeunirti-header">
              <h1 style={{ paddingTop: 40 }}>
              UNISCITI
              </h1>
            </Row>
            <div className="Comeunirti-rainbow">
              <Row>
                <Col md={8} >
                Perché <b>UNIRSI</b> a noi? 
                <br></br>      
                <b>UNISCITI</b> a noi se hai deciso di volere un servizio con <b>TEMPI DI INTERVENTO IMMEDIATI</b>, su <b>MISURE</b>, 
                sempre pronti ad <b>ASCOLTARE</b> e <b>RISOLVERE</b> le problematiche condominiali e una contabilità sempre a disposizione delle famiglie.
                <br></br> 
                Il nostro punto cardine è porre la massima attenzione sulla <b>SODDISFAZIONE DEL CLIENTE</b>, mettendo il condomino al centro del proprio condominio.
                <br></br> 
                Trovarsi a vivere in un condominio con un amministratore inadeguato, evasivo o scorretto è un’esperienza stressante e onerosa.  
                <br></br> 
                la <b>MODIFICA</b> dell’AMMINISTRATORE è una procedura divenuta dopo la riforma del condominio, finalmente <b>AGEVOLE</b>!
                <br></br> 
                Scegli <b>PROFESSIONALITA’</b> ed <b>EFFICIENZA</b>, scegli <b>BAES STUDIO </b>
                </Col>
                <Col md={4} >
                    <div className= "Comeunirti-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                          <img src={imageUrl1} alt= ''/>
                    </div>
                </Col>
              </Row>                 
            </div>

        </Container>  
      </Container>
    </section>
  );
}

export default Comeunirti;
